/**
 * Typed env access. Values come from mode files:
 * - .env.development  → npm run dev
 * - .env.production   → npm run build
 */
function required(key: string, value: string | undefined): string {
  if (!value) {
    if (import.meta.env.PROD) {
      throw new Error(`Missing required env: ${key}`);
    }
    console.warn(`[env] Missing ${key}`);
    return '';
  }
  return value;
}

const APP_ENV = import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE ?? 'development';
const IS_DEV = APP_ENV !== 'production';

/** INDIA | UAE — drives dial code, mobile regex, and x-country header. */
function resolveAppCountry(): 'INDIA' | 'UAE' {
  const raw = String(import.meta.env.VITE_COUNTRY || '')
    .trim()
    .toUpperCase();
  if (raw === 'UAE' || raw === 'AE' || raw === 'UNITED ARAB EMIRATES') return 'UAE';
  if (raw === 'INDIA' || raw === 'IN') return 'INDIA';
  if (typeof window !== 'undefined' && window.location.hostname.includes('.ae')) {
    return 'UAE';
  }
  return 'INDIA';
}

export const env = {
  APP_ENV,
  IS_DEV,
  API_BASE_URL: required(
    'VITE_API_BASE_URL',
    import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_DEV_URL,
  ),
  GOOGLE_LOCATION_KEY: import.meta.env.VITE_GOOGLE_LOCATION_KEY?.trim() || '',
  RAZORPAY_KEY: import.meta.env.VITE_RAZORPAY_KEY?.trim() || '',
  /** Active market country from VITE_COUNTRY (fallback: hostname / INDIA). */
  COUNTRY: resolveAppCountry(),
} as const;
